/* =============================================
   TISHA HYGIENE — Cookie Banner Enhancements
   v3 — fixes:
   - Removed _lastState cache (was blocking late-agent re-check)
   - Polling every 500ms while banner visible (catches React re-renders)
   - Idempotent check now reads actual inline style, not data-attribute flag
   ============================================= */
(function () {
  'use strict';

  var BANNER_SELECTOR = '#shopify-pc__banner';
  var BODY_CLASS = 'tisha-cookie-banner-open';

  var AGENT_SELECTORS = [
    '[data-testid="entrypoint"][aria-label="Shopping Agent"]',
    '[data-testid="entrypoint"][aria-label="Shop with AI"]',
    '[data-testid="entrypoint"]',
    '[aria-label="Shopping Agent"]',
    '[aria-label="Shop with AI"]'
  ];

  var SHORT_COPY = {
    title: 'Cookie consent',
    // No trailing period — inlineManagePrefs() folds the "manage preferences"
    // control into the sentence and closes it with a full stop.
    text: 'We use cookies to improve your experience and analyse site traffic. ' +
          'See our <a id="shopify-pc__banner__body-policy-link" ' +
          'href="/policies/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>'
  };

  var _running = false;
  var _pollInterval = null;

  function findAgentNodes() {
    var seen = new Set();
    var nodes = [];
    AGENT_SELECTORS.forEach(function (sel) {
      try {
        document.querySelectorAll(sel).forEach(function (n) {
          if (!seen.has(n)) { seen.add(n); nodes.push(n); }
        });
      } catch (e) {}
    });
    return nodes;
  }

  function setAgentHidden(hidden) {
    findAgentNodes().forEach(function (n) {
      try {
        if (hidden) {
          // Always re-apply if not already at opacity 0 (React may have overwritten)
          if (n.style.opacity !== '0') {
            n.style.setProperty('opacity', '0', 'important');
            n.style.setProperty('visibility', 'hidden', 'important');
            n.style.setProperty('pointer-events', 'none', 'important');
          }
        } else {
          if (n.style.opacity === '0') {
            n.style.removeProperty('opacity');
            n.style.removeProperty('visibility');
            n.style.removeProperty('pointer-events');
          }
        }
      } catch (e) {}
    });
  }

  function shortenBannerText(banner) {
    if (!banner || banner.dataset.tishaShortened === '1') return;
    var titleEl = banner.querySelector('#shopify-pc__banner__body-title');
    var bodyEl = banner.querySelector('.shopify-pc__banner__body');
    if (!bodyEl) return;
    var p = bodyEl.querySelector('p');
    if (!p) return;
    if (titleEl) titleEl.textContent = SHORT_COPY.title;
    p.innerHTML = SHORT_COPY.text;
    banner.dataset.tishaShortened = '1';
  }

  // Move Shopify's native "Manage preferences" button INTO the sentence so it
  // reads as an inline link — removes the separate full-width row on mobile and
  // trims banner height. Moves the real node, so Shopify's click handler stays.
  function inlineManagePrefs(banner) {
    if (!banner || banner.dataset.tishaManageInlined === '1') return;
    var bodyEl = banner.querySelector('.shopify-pc__banner__body');
    if (!bodyEl) return;
    var p = bodyEl.querySelector('p');
    var manageBtn = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
    // Wait for both the shortened text and the native button to be present.
    if (!p || !manageBtn || banner.dataset.tishaShortened !== '1') return;
    manageBtn.textContent = 'manage preferences';
    p.insertAdjacentText('beforeend', ' or ');
    p.appendChild(manageBtn);
    p.insertAdjacentText('beforeend', '.');
    banner.dataset.tishaManageInlined = '1';
  }

  function isBannerVisible(banner) {
    if (!banner) return false;
    if (banner.style.display === 'none') return false;
    if (!banner.offsetParent && banner.getClientRects().length === 0) return false;
    return true;
  }

  function startPolling() {
    if (_pollInterval) return;
    _pollInterval = setInterval(function () {
      var banner = document.querySelector(BANNER_SELECTOR);
      if (!banner || !isBannerVisible(banner)) {
        stopPolling();
        document.body.classList.remove(BODY_CLASS);
        setAgentHidden(false);
        return;
      }
      // Re-apply hide every 500ms — beats React re-renders
      setAgentHidden(true);
    }, 500);
  }

  function stopPolling() {
    if (_pollInterval) {
      clearInterval(_pollInterval);
      _pollInterval = null;
    }
  }

  function syncState() {
    if (_running) return;
    _running = true;
    try {
      var banner = document.querySelector(BANNER_SELECTOR);
      var visible = banner && isBannerVisible(banner);

      if (visible) {
        shortenBannerText(banner);
        inlineManagePrefs(banner);
        document.body.classList.add(BODY_CLASS);
        setAgentHidden(true);
        startPolling();
      } else {
        stopPolling();
        document.body.classList.remove(BODY_CLASS);
        setAgentHidden(false);
      }
    } catch (e) {}
    _running = false;
  }

  function init() {
    syncState();

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('#shopify-pc__banner__btn-accept') ||
          t.closest('#shopify-pc__banner__btn-decline')) {
        setTimeout(syncState, 80);
        setTimeout(syncState, 500);
      }
    }, true);

    // Initial polled checks for banner appearance (Shopify Privacy Center loads async)
    [400, 1200, 3000, 6000, 10000].forEach(function (ms) {
      setTimeout(syncState, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
